"use client";

import { type ReactNode, createContext, useContext } from "react";

import type { ModalBehaviorOptions } from "./modal-behavior";

export interface ModalContextValue {
  args: unknown;
  closeModal: (closeValue?: unknown) => void;
  setBehaviorOptions: (options: ModalBehaviorOptions) => void;
  peekState: () => unknown;
  setState: (value: unknown) => void;
}

const ModalContext = createContext<ModalContextValue | null>(null);

interface StackableModalContextProviderProps {
  children?: ReactNode;
  value: ModalContextValue;
}

export const ModalContextProvider = ({ children, value }: StackableModalContextProviderProps) => {
  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a Modal");
  }

  return context as ModalContextValue;
};
